import * as React from "react";
import HeaderBackButton from "../components/HeaderBackButton";
import {
  Box,
  Container,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  Stack,
  Typography,
} from "@mui/joy";
import {
  CryptoCurrencyFormat,
  CurrencyFormat,
  toCoinAmount,
} from "../config/services";
import {
  convertTimestamp,
  convertTimestampTime,
} from "../components/HistoryItem";
import { useLocation } from "react-router";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { useSelector } from "react-redux";

export default function TransactinDetails() {
  const userinfo = useSelector((state) => state.useInfos);
  const walletsData = useSelector((state) => state.walletsData);
  let { state } = useLocation();
  const [addrss, setaddrss] = React.useState("");
  const [coinamount, setCoinAmount] = React.useState(0);
  let {
    transaction_type,
    recipient,
    amount,
    timestamp,
    confirmation,
    cointitle,
    id,
    seen,
  } = state;

  const isCredit = transaction_type === "Credit";
  const isPending = confirmation < 3;
  const isCompleted = isPending ? "Pending" : "Completed";
  const isrecipient = isCredit ? addrss : recipient;
  const timestampset = `${convertTimestamp(timestamp)} ${convertTimestampTime(
    timestamp
  )}`;
  React.useEffect(() => {
    const docRef = doc(db, "walletaddresses", cointitle);
    getDoc(docRef).then((data) => {
      if (data.data().address) {
        setaddrss(data.data().address);
      }
    });

    const coin = walletsData.find(
      (c) => c.code === cointitle || c.codeswap === cointitle
    );
    setCoinAmount(toCoinAmount(amount, coin?.price));

    // mark as seen
    if (seen === null) return;
    const trxRef = doc(db, "users", userinfo.id, "transactions", id);
    setDoc(trxRef, { seen: true }, { merge: true }).then(() =>
      console.log("seen set")
    );
  }, [addrss, coinamount]);

  return (
    <>
      <HeaderBackButton
        title={`${isCredit ? "Receive" : "Send"} ${cointitle}`}
      />
      <Container maxWidth="sm">
        <Stack spacing={4}>
          <Box display={"flex"} justifyContent={"center"}>
            <Stack spacing={1} alignItems={"center"}>
              <Typography level="title-lg" color="primary">
                + <CryptoCurrencyFormat amount={coinamount} suffix={""} />{" "}
                {cointitle}
              </Typography>
              <Typography level="body-sm">
                <CurrencyFormat amount={amount} prefix={"$"} seperator={true} />
              </Typography>
            </Stack>
          </Box>

          <List variant="outlined" sx={{ borderRadius: 10 }}>
            <ListItem>
              <ListItemContent>Status</ListItemContent>
              {isCredit ? (
                <Typography level="body-sm" color="success">
                  Completed
                </Typography>
              ) : (
                <Typography
                  level="body-sm"
                  color={isPending ? "warning" : "success"}
                >
                  {isCompleted}
                </Typography>
              )}
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Date</ListItemContent>
              <Typography level="title-sm">{timestampset}</Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Recipient</ListItemContent>
              <Typography
                level="title-sm"
                textAlign={"right"}
                noWrap={true}
                width={"50%"}
              >
                {isrecipient}
              </Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Confirmation</ListItemContent>
              <Typography
                level="title-sm"
                textAlign={"right"}
                noWrap={true}
                width={"50%"}
              >
                {isCredit ? 3 : confirmation} / 3
              </Typography>
            </ListItem>
          </List>
        </Stack>
      </Container>
    </>
  );
}
